import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Skeleton from "@mui/material/Skeleton";

import useLcvCampaign from "./useLcvCampaign";

// The campaign dropdown at the top of every LCV admin screen. Changing it reloads the screen's data
// for that campaign, because each screen reads the selection from the same place.
export default function LcvCampaignSelect() {
     const { campaigns, selectedCampaignId, isLoading, selectCampaign } = useLcvCampaign();

     if (isLoading && campaigns.length === 0) {
          return <Skeleton variant="rounded" width={320} height={40} sx={{ mb: 2 }} />;
     }

     return (
          <Box sx={{ mb: 2 }}>
               <FormControl size="small" sx={{ minWidth: 320 }}>
                    <InputLabel id="lcv-campaign-select-label">Campaign</InputLabel>
                    <Select
                         labelId="lcv-campaign-select-label"
                         label="Campaign"
                         value={selectedCampaignId ?? ""}
                         onChange={(event) => selectCampaign(Number(event.target.value))}
                    >
                         {campaigns.map((campaign) => (
                              <MenuItem key={campaign.id} value={campaign.id}>
                                   {campaign.name}
                              </MenuItem>
                         ))}
                    </Select>
               </FormControl>
          </Box>
     );
}
